import GastroAnamnesiFisiologicaEdit from "./components/GastroAnamnesiFisiologicaEdit.vue"
import GastroAnamnesiFisiologicaView from "./components/GastroAnamnesiFisiologicaView.vue"
import GastroAnamnesiFisiologicaList from "./components/GastroAnamnesiFisiologicaList.vue"

export default {
    GastroAnamnesiFisiologicaEdit,
    GastroAnamnesiFisiologicaView,
    GastroAnamnesiFisiologicaList
}